import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { fetchSession } from '../libs/auth'

export interface User {
  id: string
  name: string
  email: string
  emailVerified: boolean
  image?: string | null
  createdAt: string
  updatedAt: string
}

export interface Session {
  id: string
  token: string
  userId: string
  expiresAt: string
  createdAt: string
  updatedAt: string
  ipAddress?: string | null
  userAgent?: string | null
}

export const useAuthStore = defineStore('auth', () => {
  const user = ref<User>()
  const session = ref<Session>()
  const isAuthenticated = computed(() => !!user.value && !!session.value)
  const userId = computed(() => user.value?.id ?? 'local')

  const isLoginOpen = ref(false)

  const initialized = ref(false)
  let initPromise: Promise<void> | null = null

  const initialize = () => {
    if (initPromise)
      return initPromise

    initPromise = fetchSession()
      .catch(() => {})
      .then(() => { initialized.value = true })

    return initPromise
  }

  const whenReady = () => initPromise ?? Promise.resolve()

  initialize()

  return {
    user,
    userId,
    session,
    isAuthenticated,
    isLoginOpen,
    whenReady,
  }
})
